import {
    create,
} from "zustand";

import type {
    StoreApi,
    UseBoundStore,
} from "zustand";

export type BaseAuthState = {
    isAuthenticated: boolean;
    userId: number | null;
    username: string | null;
    isAdmin: boolean;
    isLoading: boolean;
    setAuth: (userId: number, username: string, isAdmin: boolean) => void;
    clearAuth: () => void;
    setLoading: (loading: boolean) => void;
};

export const createAuthStore = <
    TExtra extends Record<string, unknown> = Record<string, never>,
>(
    extender?: (
        set: (partial: Partial<BaseAuthState & TExtra>) => void,
        get: () => BaseAuthState & TExtra,
    ) => TExtra,
): UseBoundStore<StoreApi<BaseAuthState & TExtra>> => {
    return create<BaseAuthState & TExtra>((set, get) => ({
        isAuthenticated: false,
        userId: null,
        username: null,
        isAdmin: false,
        isLoading: true,

        setAuth: (userId: number, username: string, isAdmin: boolean) =>
            set({
                isAuthenticated: true,
                userId,
                username,
                isAdmin,
                isLoading: false,
            } as Partial<BaseAuthState & TExtra>),

        clearAuth: () =>
            set({
                isAuthenticated: false,
                userId: null,
                username: null,
                isAdmin: false,
                isLoading: false,
            } as Partial<BaseAuthState & TExtra>),

        setLoading: (loading: boolean) =>
            set({
                isLoading: loading,
            } as Partial<BaseAuthState & TExtra>),

        ...(extender
            ? extender(
                set as (partial: Partial<BaseAuthState & TExtra>) => void,
                get,
            )
            : {} as TExtra),
    }));
};
